export default {
  groups: [
   {
      name: "Research Staff and Postdocs",
      members: [
          {
          name: "Changan Chen",
          email: "cchangan [at] stanford [dot] edu",
          desc: "Postdoctoral Researcher",
          img: "/assets/people/personnel/changan.jpg",
          web: "https://changan.io/"
        },
        {
          name: "Manling Li",
          email: "manlingl [at] stanford [dot] edu",
          desc: "Postdoctoral Researcher",
          img: "/assets/people/personnel/manling_li.jpeg",
          web: "https://limanling.github.io/"
        },
        {
          name: "Weiyu Liu",
          email: "weiyul [at] stanford [dot] edu",
          desc: "Postdoctoral Researcher",
          img: "/assets/people/personnel/weiyu_liu.jpg",
          web: "http://weiyuliu.com/"
        },
        {
          name: "Stefan Stojanov",
          email: "stojanov [at] stanford [dot] edu",
          desc: "Postdoctoral Researcher",
          img: "/assets/people/personnel/stefan_stojanov.jpg",
          web: "https://sstojanov.github.io/"
        },
        {
          name: "Shangzhe Wu",
          email: "szwu [at] stanford [dot] edu",
          desc: "Postdoctoral Researcher",
          img: "/assets/people/personnel/shangzhe_wu.png",
          web: "https://elliottwu.com/"
        },
        {
          name: "Mengdi Xu",
          email: "mengdixu [at] stanford [dot] edu",
          desc: "Postdoctoral Researcher",
          img: "/assets/people/personnel/mengdi_xu.png",
          web: "https://mxu34.github.io/"
        },
        {
          name: "Ruohan Zhang",
          email: "zharu [at] stanford [dot] edu",
          desc: "Postdoctoral Researcher",
          img: "/assets/people/personnel/ruohan_zhang.jpg",
          web: "https://ai.stanford.edu/~zharu/"
        },
      ]
    },
    {
      name: "PhD Students",
      members: [
        {
          name: "Eric R. Chan",
          email: "erchan [at] stanford [dot] edu",
          desc: "Advisors: Gordon Wetzstein, Jiajun Wu",
          img: "/assets/people/personnel/eric_chan.jpg",
          web: "https://ericryanchan.github.io/about.html"
        },
        {
          name: "Samuel Clarke",
          email: "spclarke [at] stanford [dot] edu",
          desc: "Advisor: Jiajun Wu",
          img: "/assets/people/personnel/samuel_clarke.jpg",
          web: "https://www.samuelpclarke.com"
        },
        {
          name: "Zane Durante",
          email: "durante [at] stanford [dot] edu",
          desc: "Advisor: Fei-Fei Li, Ehsan Adeli",
          img: "/assets/people/personnel/zane_durante.jpg",
          web: "https://zanedurante.github.io/",
        },
        {
          name: "Cristóbal Eyzaguirre",
          email: "ceyzaguirre [at] stanford [dot] edu",
          desc: "Advisors: Jiajun Wu, Juan Carlos Niebles",
          img: "/assets/people/personnel/cristobal_eyzaguirre.jpg",
          web: "https://ceyzaguirre4.github.io",
        },
        {
          name: "Chen Geng",
          email: "gengchen [at] stanford [dot] edu",
          desc: "Advisor: Jiajun Wu",
          img: "/assets/people/personnel/chen_geng.png",
          web: "https://chen-geng.com/"
        },
        {
          name: "Cem Gökmen",
          email: "cgokmen [at] stanford [dot] edu",
          desc: "Advisor: Fei-Fei Li",
          img: "/assets/people/personnel/cem_gokmen.jpg",
          web: "https://www.cemgokmen.com"
        },
        {
          name: "Michelle Guo",
          email: "mguo95 [at] cs [dot] stanford [dot] edu",
          desc: "Advisors: Jiajun Wu, Karen Liu",
          img: "/assets/people/personnel/michelle_guo.png",
          web: "https://www.shellguo.com"
        },
        {
          name: "Agrim Gupta",
          email: "agrim [at] cs [dot] stanford [dot] edu",
          desc: "Advisor: Fei-Fei Li",
          img: "/assets/people/personnel/agrim_gupta.jpg",
          web: "http://web.stanford.edu/~agrim/"
        },
        {
          name: "Joy Hsu",
          email: "joycj [at] stanford [dot] edu",
          desc: "Advisor: Jiajun Wu",
          img: "/assets/people/personnel/joy_hsu.png",
          web: "http://web.stanford.edu/~joycj/"
        },
        {
          name: "Kyle Hsu",
          email: "kylehsu [at] cs [dot] stanford [dot] edu",
          desc: "Advisors: Chelsea Finn, Jiajun Wu",
          img: "/assets/people/personnel/kyle_hsu.jpg",
          web: "https://www.kylehsu.me/"
        },
        {
          name: "Wenlong Huang",
          email: "wenlongh [at] stanford [dot] edu",
          desc: "Advisor: Fei-Fei Li",
          img: "/assets/people/personnel/wenlong_huang.jpeg",
          web: "https://wenlong.page/"
        },
        {
          name: "Klemen Kotar",
          email: "klemenk [at] stanford [dot] edu",
          desc: "Advisors: Jiajun Wu, Dan Yamins",
          img: "/assets/people/personnel/klemen_kotar.png",
          web: "https://klemenkotar.github.io/"
        },
        {
          name: "Chengshu (Eric) Li",
          email: "chengshu [at] stanford [dot] edu",
          desc: "Advisors: Fei-Fei Li, Silvio Savarese",
          img: "/assets/people/personnel/chengshu.jpg",
          web: "https://www.chengshuli.me"
        },
        {
          name: "Jiaman Li",
          email: "jiamanli [at] stanford [dot] edu",
          desc: "Advisors: Karen Liu, Jiajun Wu",
          img: "/assets/people/personnel/jiaman_li.jpg",
          web: "https://lijiaman.github.io"
        },
        {
          name: "Michael Lingelbach",
          email: "mjlbach [at] stanford [dot] edu",
          desc: "Advisors: Jiajun Wu, Fei-Fei Li",
          img: "/assets/people/personnel/michael_lingelbach.jpg",
          web: "https://mlingelbach.com/"
        },
        {
          name: "Chaitanya Patel",
          email: "chpatel [at] stanford [dot] edu",
          desc: "Advisors: Ehsan Adeli, Juan Carlos",
          img: "/assets/people/personnel/chaitanya.jpg",
          web: "https://chaitanya100100.github.io/"
        },
        {
          name: "Kyle Sargent",
          email: "ksarge [at] stanford [dot] edu",
          desc: "Advisors: Jiajun Wu, Fei-Fei Li",
          img: "/assets/people/personnel/kyle_sargent.jpg",
          web: "https://kylesargent.github.io/"
        },
        {
          name: "Sanjana Srivastava",
          email: "sanjana2 [at] stanford [dot] edu",
          desc: "Advisor: Fei-Fei Li",
          img: "/assets/people/personnel/sanjana_srivastava.jpg",
          web: null,
        },
        {
          name: "Fan-Yun Sun",
          email: "fanyun [at] stanford [dot] edu",
          desc: "Advisors: Nick Haber, Jiajun Wu",
          img: "/assets/people/personnel/fan_yun_sun.png",
          web: "https://cs.stanford.edu/~sunfanyun/"
        },
        {
          name: "Stephen Tian",
          email: "stephentian [at] stanford [dot] edu",
          desc: "Advisor: Jiajun Wu",
          img: "/assets/people/personnel/stephen_tian.png",
          web: "http://cs.stanford.edu/~stian"
        },
        {
          name: "Chen Wang",
          email: "chenwj [at] cs [dot] stanford [dot] edu",
          desc: "Advisors: Fei-Fei Li, Karen Liu",
          img: "/assets/people/personnel/chen_wang.jpg",
          web: "http://www.chenwangjeremy.net/"
        },
        {
          name: "Josiah Wong",
          email: "jdwong [at] stanford [dot] edu",
          desc: "Advisor: Fei-Fei Li",
          img: "/assets/people/personnel/josiah_wong.png",
          web: "http://www.jowo.me/"
        },
        {
          name: "Bohan Wu",
          email: "bohanwu [at] stanford [dot] edu",
          desc: "Advisor: Fei-Fei Li",
          img: "/assets/people/personnel/bohan_wu.jpeg",
        },
        {
          name: "Tiange Xiang",
          email: "xtiange [at] stanford [dot] edu",
          desc: "Advisors: Fei-Fei Li, Scott Delp, Ehsan Adeli",
          img: "/assets/people/personnel/tiange_xiang.jpeg",
          web: "https://tiangexiang.github.io/"
        },
        {
          name: "Hong-Xing (Koven) Yu",
          email: "koven [at] stanford [dot] edu",
          desc: "Advisor: Jiajun Wu",
          img: "/assets/people/personnel/koven_yu.png",
          web: "https://kovenyu.com/"
        },
        {
          name: "Yunzhi Zhang",
          email: "yzzhang [at] stanford [dot] edu",
          desc: "Advisor: Jiajun Wu",
          img: "/assets/people/personnel/yunzhi_zhang.jpg",
          web: "https://cs.stanford.edu/~yzzhang/"
        }

        // { name: "Barry Chai ",
        //   email: null,
        //   desc: "Research Assistant",
        //   img: "http://vision.stanford.edu/img/barry.jpg",
        //   web: null
        // },
      ]
    },
    {
      name: "Visiting Students",
      members: [
        {
          name: "Yunhao Ge",
          img: "/assets/people/personnel/yunhao_ge.jpg",
          web: "https://gyhandy.github.io/"
        },
        {
          name: "Ryosuke Sawata",
          img: "/assets/people/personnel/ryosuke_sawata.jpg",
        }
      ]
    },
    {
      name: "Robots",
      members: [
        {
          name: "Marvin",
          desc: "Tiago",
          img: "/assets/people/robots/marvin.png",
        },
        {
          name: "C3PO",
          desc: "Sawyer Arm",
          img: "/assets/people/robots/c3po.png",
        },
        {
          name: "TARS",
          desc: "Sawyer Arm",
          img: "/assets/people/robots/tars.png",
        },
        {
          name: "Brainiac",
          desc: "Franka Emika Panda Arm",
          img: "/assets/people/robots/brainiac.png",
        },
        {
          name: "Francess",
          desc: "Franka Emika Panda Arm",
          img: "/assets/people/robots/francess.jpg",
        },
        {
          name: "Kid",
          desc: "Franka Emika Panda Arm",
          img: "/assets/people/robots/kid.jpg",
        },
        {
          name: "Sonicbot",
          desc: "Turtlebot",
          img: "/assets/people/robots/sonicbot.png",
        },
      ],
    },
    {
      name: "Alumni - Postdocs",
      members: [
          {
          name: "Yunzhu Li",
          email: null,
          desc: "2022--2023",
          img: null,
          web: "https://yunzhuli.github.io/"
        },
        {
          name: "Ruohan Gao",
          email: null,
          desc: "2021--2023",
          img: null,
          web: "http://ai.stanford.edu/~rhgao/"
        },
        {
          name: "Roberto Martín-Martín",
          email: null,
          desc: "2018--2022",
          img: null,
          web: "https://robertomartinmartin.com/"
        },
        {
          name: "Huazhe Xu",
          email: null,
          desc: "2021--2022",
          img: null,
          web: "http://hxu.rocks/"
        },
        {
          name: "Claudia D'Arpino",
          email: null,
          desc: "2019--2021",
          img: null,
          web: "https://ai.stanford.edu/~cdarpino/"
        },
        {
          name: "Amir Zamir",
          email: null,
          desc: "2015--2019",
          img: null,
          web: "https://vilab.epfl.ch/zamir/"
        },
        {
          name: "Animesh Garg",
          email: null,
          desc: "2017--2019",
          img: null,
          web: "https://animesh.garg.tech/"
        },
        {
          name: "Yanan Sui",
          email: null,
          desc: "2018--2019",
          img: null,
          web: "http://www.yanansui.com/"
        },
        {
          name: "Marynel Vazquez",
          email: null,
          desc: "2017--2018",
          img: null,
          web: "http://www.marynel.net/"
        },
        {
          name: "Guido Pusiol",
          email: null,
          desc: "2013--2017",
          img: null,
        },
        {
          name: "Ozan Sener",
          email: null,
          desc: "2016--2018",
          img: null,
          web: "http://ozansener.net/"
        },
        {
          name: "Alex Alahi",
          email: null,
          desc: "2013--2017",
          img: null,
          web: "https://people.epfl.ch/alexandre.alahi?lang=en"
        },
        {
          name: "Judy Hoffman",
          email: null,
          desc: "2016--2017",
          img: null,
          web: "https://faculty.cc.gatech.edu/~judy/"
        },
        {
          name: "Joseph Lim",
          email: null,
          desc: "2015--2016",
          img: null,
          web: "https://clvrai.com/web_lim/"
        },
        {
          name: "Lamberto Ballan",
          email: null,
          desc: "2014--2016",
          img: null,
          web: "http://www.lambertoballan.net/"
        },
        {
          name: "Yu Xiang",
          email: null,
          desc: "2015--2016",
          img: null,
          web: "https://yuxng.github.io/"
        },
        {
          name: "Hyun Oh Song",
          email: null,
          desc: "2014--2016",
          img: null,
          web: "https://mllab.snu.ac.kr/hyunoh/"
        },
        {
          name: "Michelle Greene",
          email: null,
          desc: "2013--2015",
          img: null,
          web: "http://michellegreene.org/"
        },
        {
          name: "Tian Lan",
          email: null,
          desc: "2013--2014",
          img: null,
          web: "http://cs.stanford.edu/~taranlan/"
        },
        {
          name: "Roozbeh Mottaghi",
          email: null,
          desc: "2013--2014",
          img: null,
          web: "http://roozbehm.info/"
        },
        {
          name: "Alireza Fathi",
          email: null,
          desc: "2013--2014",
          img: null,
          web: "https://www.alirezafathi.org/"
        },
        {
          name: "Roni Mittelman",
          email: null,
          desc: "2011--2013",
          img: null,
          web: null
        },
        {
          name: "Jingen Liu",
          email: null,
          desc: "2010--2011",
          img: null,
        },
      ]
    },
    {
      name: "Alumni - Research Staff",
      members: [
        {
          name: "Rohun Kulkarni",
          email: null,
          desc: "2019--2021",
          img: null,
          web: null
        },
        {
          name: "Hamid Rezatofighi",
          email: null,
          desc: "2018--2020",
          img: null,
          web: "https://vl4ai.erc.monash.edu/"
        },
      ]
    },
    {
      name: "Alumni - PhD Students",
      members: [
          {
          name: "Lyne P. Tchapmi",
          desc: "2017--2023",
          web: null
        },
        {
          name: "Bokui (William) Shen",
          desc: "2018--2023",
          web: "http://cs.stanford.edu/~willshen"
        },
        {
          name: "Zelun (Alan) Luo",
          desc: "2017--2023",
          web: "http://alan.vision/"
        },
        {
          name: "Rachel Luo",
          desc: "2017--2023",
          web: "https://rsluo.github.io/"
        },
        {
          name: "Trevor Standley",
          desc: "2015--2023",
          web: "http://trevorstandley.com/"
        },
        {
          name: "Suraj Nair",
          desc: "2018--2023",
          web: "http://surajnair.com"
        },
        {
          name: "Andrey Kurenkov",
          desc: "2017--2023",
          web: "http://www.andreykurenkov.com/"
        },
        {
          name: "Sumith Kulal",
          desc: "2018--2023",
          web: "https://cs.stanford.edu/~sumith/"
        },
        {
          name: "Shyamal Buch",
          desc: "2016--2022",
          web: "https://cs.stanford.edu/~shyamal/"
        },
        {
          name: "Ajay Mandlekar",
          email: null,
          desc: "2016--2022",
          img: null,
          web: "https://ai.stanford.edu/~amandlek/"
        },
        {
          name: "JunYoung Gwak",
          desc: "2015--2022",
          web: "http://jgwak.com/"
        },
        {
          name: "Fei Xia",
          email: null,
          desc: "2016--2021",
          img: null,
          web: "https://fxia22.github.io/"
        },
        {
          name: "Kevin Chen",
          email: null,
          desc: "2014--2021",
          img: null,
          web: "https://cs.stanford.edu/~kchen92/"
        },
        {
          name: "Jim Fan",
          email: null,
          desc: "2016--2021",
          img: null,
          web: "http://jimfan.me/"
        },
        {
          name: "Ranjay Krishna",
          email: null,
          desc: "2016--2021",
          img: null,
          web: "http://ranjaykrishna.com/"
        },
        {
          name: "Kuan Fang",
          email: null,
          desc: "2015--2021",
          img: null,
          web: "http://ai.stanford.edu/~kuanfang/"
        },
        {
          name: "Danfei Xu",
          email: null,
          desc: "2015--2021",
          img: null,
          web: "http://cs.stanford.edu/~danfei/"
        },
        {
          name: "Jingwei Ji",
          email: null,
          desc: "2015--2021",
          img: null,
          web: "https://jingweij.github.io"
        },
        {
          name: "Damian Mrowca",
          email: null,
          desc: "2016--2021",
          img: null,
          web: null
        },
        {
          name: "Albert Haque",
          email: null,
          desc: "2016--2020",
          img: null,
          web: "https://alberthaque.com/"
        },
        {
          name: "Iro Armeni",
          email: null,
          desc: "2015--2020",
          img: null,
          web: "http://cs.stanford.edu/~iarmeni/"
        },
        {
          name: "Christopher B. Choy",
          email: null,
          desc: "2014--2020",
          img: null,
          web: "http://chrischoy.org/"
        },
        {
          name: "De-An Huang",
          email: null,
          desc: "2015--2020",
          img: null,
          web: "http://ai.stanford.edu/~dahuang/"
        },
        {
          name: "Yuke Zhu",
          email: null,
          desc: "2013--2020",
          img: null,
          web: "https://www.cs.utexas.edu/~yukez/"
        },
        {
          name: "Serena Yeung",
          email: null,
          desc: "2013--2018",
          img: null,
          web: "http://ai.stanford.edu/~syyeung/"
        },
        {
          name: "Justin Johnson",
          email: null,
          desc: "2012--2018",
          img: null,
          web: "http://cs.stanford.edu/people/jcjohns"
        },
        {
          name: "Amir Sadeghian",
          email: null,
          desc: "2013--2018",
          img: null,
          web: null
        },
        {
          name: "Simon Kalouche",
          email: null,
          desc: "2016--2018",
          img: null,
          web: "https://web.stanford.edu/~kalouche/"
        },
        {
          name: "John Emmons",
          email: null,
          desc: "2016--2018",
          img: null,
          web: "http://johnemmons.com/"
        },
        {
          name: "Timnit Gebru",
          email: null,
          desc: "2012--2017",
          img: null,
          web: "http://ai.stanford.edu/~tgebru/"
        },
        {
          name: "Jon Krause",
          email: null,
          desc: "2011--2016",
          img: null,
          web: "http://ai.stanford.edu/~jkrause"
        },
        {
          name: "Andrej Karpathy",
          email: null,
          desc: "2011--2016",
          img: null,
          web: "https://karpathy.ai/"
        },
        {
          name: "Vignesh Ramanathan",
          email: null,
          desc: "2011--2016",
          img: null,
          web: "http://ai.stanford.edu/~vigneshr"
        },
        {
          name: "Marius Cătălin Iordan",
          email: null,
          desc: "2009--2016",
          img: null,
          web: "http://cs.stanford.edu/~mci"
        },
        {
          name: "David Held",
          email: null,
          desc: "2012--2016",
          img: null,
          web: "http://davheld.github.io/"
        },
        {
          name: "Yu Xiang",
          email: null,
          desc: "2010--2016",
          img: null,
          web: "https://yuxng.github.io"
        },
        {
          name: "Olga Russakovsky",
          email: null,
          desc: "2010--2015",
          img: null,
          web: "http://ai.stanford.edu/~olga/"
        },
        {
          name: "Kevin Tang",
          email: null,
          desc: "2010--2015",
          img: null,
          web: "http://ai.stanford.edu/~kdtang/"
        },
        {
          name: "Chris Baldassano",
          email: null,
          desc: "2010--2015",
          img: null,
          web: "http://www.chrisbaldassano.com/"
        },
        {
          name: "Sid Ying-Ze Bao",
          email: null,
          desc: "2009--2013",
          img: null,
          web: null
        },
        {
          name: "Gaurav Pandey",
          email: null,
          desc: "2008--2013",
          img: null,
          web: "https://sites.google.com/view/gauravpandey/"
        },
        {
          name: "Jia Deng",
          email: null,
          desc: "2008--2013",
          img: null,
          web: "https://www.cs.princeton.edu/~jiadeng/"
        },
        {
          name: "Bangpeng Yao",
          email: null,
          desc: "2008--2013",
          img: null,
          web: "http://ai.stanford.edu/~bangpeng/"
        },
        {
          name: "Wongun Choi",
          email: null,
          desc: "2008--2013",
          img: null,
          web: "http://www-personal.umich.edu/~wgchoi/"
        },
        {
          name: "Jason Clemons",
          email: null,
          desc: "2008--2013",
          img: null,
          web: "https://research.nvidia.com/person/jason-clemons"
        },
        {
          name: "Jia Li",
          email: null,
          desc: "2006--2011",
          img: null,
          web: "http://vision.stanford.edu/lijiali/"
        },
        {
          name: "Juan Carlos Niebles",
          email: null,
          desc: "2005--2010",
          img: null,
          web: "http://www.niebles.net/"
        }
      ]
    },
    {
      name: "Alumni - Robots",
      members: [
        {
          name: "BB-8",
          desc: "Sawyer Arm",
          img: "/assets/people/robots/bb-8.png",
        },
        {
          name: "Bender",
          desc: "Sawyer Arm",
          img: "/assets/people/robots/bender.png",
        },
        {
          name: "HAL",
          desc: "Sawyer Arm",
          img: "/assets/people/robots/hal.png",
        },
        {
          name: "The Vision",
          desc: "Sawyer Arm",
          img: "/assets/people/robots/thevision.png",
        },
        {
          name: "Goddard",
          desc: "Franka Emika Panda Arm",
          img: "/assets/people/robots/goddard.png",
        }
      ]
    }
  ]
};
